import axios from 'axios'
import type { Customer } from './types'

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
})

export const CUSTOMER_STORAGE_KEY = 'hotel-public-customer'
export const PUBLIC_AGENT_SESSION_KEY = 'hotel-public-agent-session'

export function getStoredAuth(): { token: string; customer: Customer } | null {
  const raw = localStorage.getItem(CUSTOMER_STORAGE_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setStoredAuth(auth: { token: string; customer: Customer } | null) {
  if (!auth) {
    localStorage.removeItem(CUSTOMER_STORAGE_KEY)
    return
  }
  localStorage.setItem(CUSTOMER_STORAGE_KEY, JSON.stringify(auth))
}

export function getStoredPublicAgentSession(): { id: number; web_session_id: string } | null {
  const raw = localStorage.getItem(PUBLIC_AGENT_SESSION_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setStoredPublicAgentSession(session: { id: number; web_session_id: string } | null) {
  if (!session) {
    localStorage.removeItem(PUBLIC_AGENT_SESSION_KEY)
    return
  }
  localStorage.setItem(PUBLIC_AGENT_SESSION_KEY, JSON.stringify(session))
}

export function getAmenityList(value: string[] | Record<string, boolean>) {
  if (Array.isArray(value)) return value
  return Object.entries(value || {}).filter(([, enabled]) => Boolean(enabled)).map(([key]) => key)
}

export function getPrimaryImage(images: { image: string; is_primary?: boolean }[], fallback?: string) {
  return images.find((img) => img.is_primary)?.image || images[0]?.image || fallback || ''
}
